import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LockForeverToggle.module.css';

/**
 * Whether a football bolão's participants may lock a prediction "forever" —
 * see `bolaos.allowLockForever`'s doc comment for the mechanic itself.
 *
 * The same checkbox-plus-help-button shape as the per-question version of
 * this toggle in `QuestionTypeBlockEditor`, since it's the same idea one
 * level up: a custom bolão's questions each opt in individually, a football
 * bolão has exactly one lock mechanic (real matches, not questions) so it
 * gets exactly one toggle, at the bolão level.
 */
export default function LockForeverToggle({
  checked,
  onChange,
  disabled = false,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  const [helpOpen, setHelpOpen] = useState(false);

  return (
    <div>
      <label className={styles.row}>
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        {t('createCompetition.allowLockForeverLabel')}
        <button
          type="button"
          className={styles.helpButton}
          aria-label={t('createCompetition.allowLockForeverHelpLabel')}
          onClick={(e) => {
            e.preventDefault();
            setHelpOpen((open) => !open);
          }}
        >
          ?
        </button>
      </label>
      {helpOpen ? (
        <p className={styles.helpText}>{t('createCompetition.allowLockForeverHelp')}</p>
      ) : null}
    </div>
  );
}
